export const currentUserSelector = (state) => state.auth.user;
